import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetPaineisGerenciais, type ReadPainelGerencialDto } from './painel-gerencial.service';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useState } from 'react';

export default function PaineisGerenciaisAdminIndex() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadPainelGerencialDto[], number]>([[], 0]);
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    const termo = tableState.filter.trim();
    GetPaineisGerenciais(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      termo || undefined,
    )
      .then((result) => setRegistros([result.objects, result.count]))
      .catch((res) => toast.error(String(res) || ''));
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({
      primary: { label: 'Cadastrar', href: Links.PaineisGerenciais_Admin_Criar, onClick: () => {} },
    });
    return () => setActions({});
  }, [setActions]);

  const colunas: Column<ReadPainelGerencialDto>[] = [
    { key: 'nome', header: 'Nome' },
    { key: 'areaResponsavel', header: 'Área' },
    {
      key: 'ativo',
      header: 'Situação',
      render: (row) => (row.ativo ? 'Ativo' : 'Inativo'),
    },
    {
      key: 'usuarios',
      header: 'Usuários',
      render: (row) => <>{row.usuarios?.length ?? 0}</>,
    },
    {
      key: 'acoes',
      header: 'Ações',
      render: (row) => (
        <Link className="link-secondary" to={`${Links.PaineisGerenciais_Admin_Editar}/${row.id}`}>
          Editar
        </Link>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <h3>Cadastro de Painéis</h3>
        <span className="blockquote-footer pb-4 text-end">
          Painéis gerenciais do Metabase e usuários com acesso.
        </span>
        <hr className="pb-4" />
      </div>

      <DataTable
        columns={colunas}
        data={registros[0]}
        initialSortKey="nome"
        onChange={handleBuscar}
        serverSide={true}
        states={tableState}
        totalRecords={registros[1]}
      />
    </div>
  );
}
